import { VehicleTypeAlertGroupInput } from './vehicle-type-alert-group-input.model';
import { VehicleDetailsAlertGroupInput } from './vehicle-details-alert-group-input.model';
import { BranchDetailsAlertGroupInput } from './branch-details-alert-group-input.model';


export class AlertGroupAddInput implements IAlertGroupAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId!: number;
    /** The branch details type must be one of "All" or "Select" */
    branchDetailType!: string;
    /** The vehicle type must be one of "All" or "Select" */
    vehicleType!: string;
    /** The vehicle details type must be one of "All" or "Select" */
    vehicleDetailsType!: string;
    /** The alert group name with 255 character limit */
    alertGroupName!: string;
    /** The valid days must be one of "Everyday" or "Custom" */
    validDays!: string;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    sunday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    monday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    tuesday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    wednesday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    thursday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    friday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    saturday!: number;
    /** The alert from time with 10 character limit */
    fromTime!: string;
    /** The alert to time with 10 character limit */
    toTime!: string;
    /** The auto-generated id of the time zone master */
    timeZoneId!: number;
    vehicleTypeAlertGroup!: VehicleTypeAlertGroupInput[];
    vehicleDetailsAlertGroup!: VehicleDetailsAlertGroupInput[];
    branchDetailsAlertGroup!: BranchDetailsAlertGroupInput[];

    constructor(data?: IAlertGroupAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyDetailsId = _data["companyDetailsId"];
            this.branchDetailType = _data["branchDetailType"];
            this.vehicleType = _data["vehicleType"];
            this.vehicleDetailsType = _data["vehicleDetailsType"];
            this.alertGroupName = _data["alertGroupName"];
            this.validDays = _data["validDays"];
            this.sunday = _data["sunday"];
            this.monday = _data["monday"];
            this.tuesday = _data["tuesday"];
            this.wednesday = _data["wednesday"];
            this.thursday = _data["thursday"];
            this.friday = _data["friday"];
            this.saturday = _data["saturday"];
            this.fromTime = _data["fromTime"];
            this.toTime = _data["toTime"];
            this.timeZoneId = _data["timeZoneId"];
            if (Array.isArray(_data["vehicleTypeAlertGroup"])) {
                this.vehicleTypeAlertGroup = [] as any;
                for (let item of _data["vehicleTypeAlertGroup"])
                    this.vehicleTypeAlertGroup!.push(VehicleTypeAlertGroupInput.fromJS(item));
            }
            if (Array.isArray(_data["vehicleDetailsAlertGroup"])) {
                this.vehicleDetailsAlertGroup = [] as any;
                for (let item of _data["vehicleDetailsAlertGroup"])
                    this.vehicleDetailsAlertGroup!.push(VehicleDetailsAlertGroupInput.fromJS(item));
            }
            if (Array.isArray(_data["branchDetailsAlertGroup"])) {
                this.branchDetailsAlertGroup = [] as any;
                for (let item of _data["branchDetailsAlertGroup"])
                    this.branchDetailsAlertGroup!.push(BranchDetailsAlertGroupInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlertGroupAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new AlertGroupAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyDetailsId"] = this.companyDetailsId;
        data["branchDetailType"] = this.branchDetailType;
        data["vehicleType"] = this.vehicleType;
        data["vehicleDetailsType"] = this.vehicleDetailsType;
        data["alertGroupName"] = this.alertGroupName;
        data["validDays"] = this.validDays;
        data["sunday"] = this.sunday;
        data["monday"] = this.monday;
        data["tuesday"] = this.tuesday;
        data["wednesday"] = this.wednesday;
        data["thursday"] = this.thursday;
        data["friday"] = this.friday;
        data["saturday"] = this.saturday;
        data["fromTime"] = this.fromTime;
        data["toTime"] = this.toTime;
        data["timeZoneId"] = this.timeZoneId;
        if (Array.isArray(this.vehicleTypeAlertGroup)) {
            data["vehicleTypeAlertGroup"] = [];
            for (let item of this.vehicleTypeAlertGroup)
                data["vehicleTypeAlertGroup"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleDetailsAlertGroup)) {
            data["vehicleDetailsAlertGroup"] = [];
            for (let item of this.vehicleDetailsAlertGroup)
                data["vehicleDetailsAlertGroup"].push(item.toJSON());
        }
        if (Array.isArray(this.branchDetailsAlertGroup)) {
            data["branchDetailsAlertGroup"] = [];
            for (let item of this.branchDetailsAlertGroup)
                data["branchDetailsAlertGroup"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAlertGroupAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId: number;
    /** The branch details type must be one of "All" or "Select" */
    branchDetailType: string;
    /** The vehicle type must be one of "All" or "Select" */
    vehicleType: string;
    /** The vehicle details type must be one of "All" or "Select" */
    vehicleDetailsType: string;
    /** The alert group name with 255 character limit */
    alertGroupName: string;
    /** The valid days must be one of "Everyday" or "Custom" */
    validDays: string;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    sunday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    monday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    tuesday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    wednesday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    thursday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    friday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    saturday: number;
    /** The alert from time with 10 character limit */
    fromTime: string;
    /** The alert to time with 10 character limit */
    toTime: string;
    /** The auto-generated id of the time zone master */
    timeZoneId: number;
    vehicleTypeAlertGroup: VehicleTypeAlertGroupInput[];
    vehicleDetailsAlertGroup: VehicleDetailsAlertGroupInput[];
    branchDetailsAlertGroup: BranchDetailsAlertGroupInput[];
}

